import React, { useEffect, useRef, useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import "../../EmployeeScreens/EMPLeavesRequest/EMPLeavesRequest.css";
import Select from "react-select";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import { Apiurl, GetToken, RemoveUserSession } from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../Components/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
const EMPLeavesRequest = () => {
  const [loading, setLoading] = useState(false);

  const LoginToken = GetToken();
  const [profileData, setProfileData] = useState([]);
  const navigate = useNavigate();
  const [minLeaveToDate, setMinLeaveToDate] = useState(null);
  const [errorName, setErrorName] = useState(false);
  const [errorLeaveType, setErrorLeaveType] = useState(false);
  const [errorLeaveFrom, setErrorLeaveFrom] = useState(false);
  const [errorLeaveTo, setErrorLeaveTo] = useState(false);
  const [errorNoOfDays, setErrorNoOfDays] = useState(false);
  const [errorReason, setErrorReason] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [selectedLeaveType, setSelectedLeaveType] = useState(null);
  const [data, setdata] = useState("");
  const [MedicalDocumentsfile, setMedicalDocumentsFile] = useState(null);
  console.log(MedicalDocumentsfile,"MedicalDocumentsfile");
  const fileInputRef = useRef(null);
  console.log(fileInputRef,"fileInputRef");

  const [applyLeaves, setApplyLeaves] = useState({
    Name: "",
    LeaveType: "",
    LeaveFrom: "",
    LeaveTo: "",
    NoOfDays: "",
    Reason: "",
  });
  console.log(applyLeaves,"applyLeaves");
  const [allLeavesList, setallLeavesList] = useState([]);
  const location = useLocation();
  const leaveRequestData = location.state?.leaveRequestData;
  useEffect(() => {
    if (leaveRequestData) {
      setApplyLeaves({
        LeaveType: leaveRequestData?.LeaveTypes,
        LeaveFrom: leaveRequestData?.StartDate?.split("T")[0],
        LeaveTo: leaveRequestData?.EndDate?.split("T")[0],
        NoOfDays: leaveRequestData?.NumberofDays,
        Reason: leaveRequestData?.Reason,
      });
    }
  }, [leaveRequestData]);
  useEffect(() => {
    if (applyLeaves?.LeaveFrom && applyLeaves?.LeaveTo) {
      const leaveStartDate = moment(applyLeaves?.LeaveFrom);
      const leaveEndDate = moment(applyLeaves?.LeaveTo);
      const duration = moment.duration(leaveEndDate.diff(leaveStartDate));
      const days = duration.asDays() + 1;
      setApplyLeaves({ ...applyLeaves, NoOfDays: days });
    }
  }, [applyLeaves?.LeaveFrom, applyLeaves?.LeaveTo]);

  const validate = () => {
    if (!applyLeaves?.LeaveFrom) {
      setErrorLeaveFrom("userLeaveFrom");
      return false;
    }
    if (!applyLeaves?.LeaveTo) {
      setErrorLeaveTo("userLeaveTo");
      return false;
    }
    if (!applyLeaves?.NoOfDays) {
      setErrorNoOfDays("userNoOfdays");
      return false;
    }
    if (!applyLeaves?.LeaveType) {
      setErrorLeaveType("userLeaveType");
      return false;
    }
    if (!applyLeaves?.Reason) {
      setErrorReason("userReason");
      return false;
    }
    return true;
  };
  const [previousDate, setPreviousDate] = useState(null);

  const handleLeaveSubmit = () => {
    if (!validate()) return;
    setLoading(true);
    const LoginToken = GetToken();
    // const data = {};
    const formData = new FormData();
    if (leaveRequestData) {
      formData.append("Id",leaveRequestData?.Id);
    }
    formData.append("StartDate",applyLeaves.LeaveFrom);
    formData.append("EndDate",applyLeaves.LeaveTo)
    formData.append("Reason",applyLeaves.Reason)
    formData.append("NumberofDays",applyLeaves?.NoOfDays);
    formData.append("LeaveType",applyLeaves?.LeaveType?.Id)
    if (applyLeaves.LeaveType.Name === "Sick Leave" && MedicalDocumentsfile) {
      formData.append("MedicalDocuments", MedicalDocumentsfile);
    }
    setPreviousDate(applyLeaves.LeaveFrom || applyLeaves.LeaveTo);





    // data.Id = leaveRequestData?.Id;
    // data.StartDate = applyLeaves?.LeaveFrom;
    // data.EndDate = applyLeaves?.LeaveTo;
    // data.Reason = applyLeaves?.Reason;
    // data.NumberofDays = applyLeaves?.NoOfDays;
    // data.LeaveType = applyLeaves?.LeaveType?.Id;
    // setPreviousDate(data.StartDate || data.EndDate);
    const option = {
      
      method: "POST",
      headers: {
        // "access-control-allow-origin": "*",
        // "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/ApplyLeave`,
      // data: { data: JSON.stringify(data) },
      data: formData,
    };
    axios(option)
    .then((e) => {
        if (previousDate === data.StartDate && data.EndDate) {
          toast.error("0111100000 date ");
          return false;
        } else if (e?.status === 200) {
          toast.success(e?.data?.message);
          setApplyLeaves({
            // Name: "",
            LeaveType: "",
            LeaveFrom: "",
            LeaveTo: "",  
            NoOfDays: "",
            Reason: "",
          });
          // setErrorName(false);
          setErrorLeaveType(false);
          setErrorLeaveFrom(false);
          setErrorLeaveTo(false);
          setErrorNoOfDays(false);
          setErrorReason(false);
          navigate("/Emp/EMPLeaves");
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
        setLoading(false);
        if (
          error?.message === "Network Error" &&
          error?.code === "ERR_NETWORK"
        ) {
          toast.error("Your Session has been expired");
          RemoveUserSession();
          navigate("/");
        }
      });
  };
  const [leaveTypeData, setLeaveTypeData] = useState([]);

  const RetrieveLeaveTypes = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/GetLeaveTypes`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        const modifiedData = data?.map((leave) => {
          if (leave.Name === "OD") {
            return { ...leave, Name: "Outdoor Leave" };
          } else {
            return leave;
          }
        });
        setLeaveTypeData(modifiedData);
        setallLeavesList(modifiedData);
      })
      .catch((err) => {
        console.error("Error fetching leave types:", err);
      });
  };

  useEffect(() => {
    RetrieveLeaveTypes();
  }, []);
  useEffect(() => {
    let filterData;

    if (applyLeaves?.NoOfDays > 1 && applyLeaves?.NoOfDays <= 6) {
      filterData = allLeavesList?.filter(
        (item) => item?.Name !== "Half Day" && item?.Name !== "Short Leave"
      );
    } else if (applyLeaves?.NoOfDays === 6) {
      filterData = allLeavesList?.filter(
        (item) => item?.Name === "Casual Leave" || item?.Name === "Sick Leave"
      );
    } else if (applyLeaves?.NoOfDays > 6) {
      filterData = allLeavesList?.filter(
        (item) => item?.Name === "Casual Leave" || item?.Name === "OD"
      );
    } else {
      filterData = allLeavesList;
    }
    setLeaveTypeData(filterData);
  }, [applyLeaves, allLeavesList]);

  const handleLeaveTypeChange = (selectedOption) => {
    if (
      applyLeaves?.NoOfDays > 2 &&
      (selectedOption?.Name === "Short Leave" ||
        selectedOption?.Name === "Half Day")
    ) {
      toast.warning(
        "Sick Leave and Half Day are not allowed for more than 2 days."
      );
      return;
    }
    if (applyLeaves?.NoOfDays > 6 && selectedOption?.Name === "Sick Leave") {
      toast.warning("Sick Leave is not allowed for more than 6 days.");
      return;
    }
    setSelectedLeaveType(selectedOption);
    setApplyLeaves({ ...applyLeaves, LeaveType: selectedOption });

    const today = new Date();
    const fifteenDaysAgo = new Date(today);
    fifteenDaysAgo.setDate(today.getDate() - 15);
    const last15DaysDateString = fifteenDaysAgo.toISOString().split("T")[0];
  
    if (selectedOption?.Name === "Sick Leave") {
      setMinLeaveToDate(last15DaysDateString);
    } else {
      setMinLeaveToDate(null); 
    }
  };
  const handleCancelFields = () => {
    setApplyLeaves({
      LeaveType: "",
      LeaveFrom: "",
      LeaveTo: "",
      NoOfDays: "",
      Reason: "",
    });
    setErrorName(false);
    setErrorLeaveType(false);
    setErrorLeaveFrom(false);
    setErrorLeaveTo(false);
    setErrorNoOfDays(false);
    setErrorReason(false);
  };
  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);
  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);
    GetProfile();
    return () => clearTimeout(timeout);
  }, []);
  const GetProfile = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Profile/GetProfile`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        setProfileData(data);
      })
      .catch((error) => {
        if (
          error?.message === "Network Error" &&
          error?.code === "ERR_NETWORK"
        ) {
          toast.error("Your Session has been expired");
          RemoveUserSession();
          navigate("/");
        }
      });
  };
  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    console.log(file,"111file");
    setMedicalDocumentsFile(file);
  };
  const last15DaysDate = () => {
    const today = new Date();
    const fifteenDaysAgo = new Date(today);
    fifteenDaysAgo.setDate(today.getDate() - 15);
    return fifteenDaysAgo.toISOString().split("T")[0];
  };
  const [minDatenew, setMinDatenew] = useState('');

  const calculateMinDate = () => {
    if (applyLeaves.LeaveType.Name === "Sick Leave") { 
      const today = new Date();
      today.setDate(today.getDate() - 6);
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, '0');
      const day = today.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
  }
  return minDate
  };
  useEffect(() => {
    setMinDatenew(calculateMinDate());
  }, [applyLeaves]);


  // const currentDate = new Date();
  // currentDate.setDate(currentDate.getDate() - 15);
  // const firstDateOfMonth = new Date(
  //   currentDate.getFullYear(),
  //   currentDate.getMonth(),
  //   1
  // );
  // const minDate = firstDateOfMonth.toISOString().split("T")[0];
  // currentDate.setDate(currentDate.getDate() - 45);


  const currentDate = new Date();
  let minDate = new Date(currentDate.getTime());
  minDate.setDate(currentDate.getDate() - 15);
  minDate = minDate.toISOString().split("T")[0];
  // let min = applyLeaves.LeaveType.Name === "Sick Leave" ? minDate : minDate;

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
          <section
            className={
              showSidebar
                ? "EMP-addEmloyees-section"
                : "EMP-addEmloyees-section-new"
            }
          >
            <div className="EMP-addEmloyees-all-icons">
              <div>
                <p className="MAIN-HEADING">
                  {leaveRequestData ? "Edit Leaves" : "Apply Leaves"}
                </p>
              </div>
              <div className="dashboiard-inner-header">
                <BiHomeAlt className="EMP-home-icon-header-inn" />
                <MdKeyboardArrowRight />
                <p> Leaves Management </p>
                <MdKeyboardArrowRight />
                <p>{leaveRequestData ? "Edit Leaves" : "Apply Leaves"}</p>
              </div>
            </div>
            <div className="EMP-Addemployee-main-container">
              <div className="EMP-Addemployee-outter-container">
                <div className="EMP-Addemployee-inner-container">
                  <div className="EMP-AddEmployee-heading">
                    <p>{leaveRequestData ? "Edit Leaves" : "Apply Leaves"}</p>
                  </div>
                  <div className="EMP-Addemployee-inner-box row">
                    
                    <div className="Addemployee-inputs col-md12">
                      <label htmlFor="">Leave From</label>
                      <input
                        value={applyLeaves.LeaveFrom}
                        type="date"
                        onChange={(e) => {
                          const selectedDate = e?.target?.value;
                          setApplyLeaves({
                            ...applyLeaves,
                            LeaveFrom: selectedDate,
                            LeaveTo: "",
                            NoOfDays: "",
                            // LeaveType: "",
                          });
                          if (!applyLeaves.LeaveType.Name === "Sick Leave") {
                            setApplyLeaves({
                              ...applyLeaves,
                              LeaveType: "",
                            });
                          }
                          setMinLeaveToDate(selectedDate);
                          setErrorLeaveType();
                        }}
                        min={applyLeaves.LeaveType.Name === "Sick Leave" ? minDatenew : minDate}

                        // min={minDatenew}
                        // max={applyLeaves?.LeaveType === "Sick Leave" ? last15DaysDate() : null}

                      />
                      {errorLeaveFrom === "userLeaveFrom" &&
                      !applyLeaves?.LeaveFrom ? (
                        <span className="contact_error-dob">
                          Leave From is required.
                        </span>
                      ) : null}
                    </div>
                    <div className="Addemployee-inputs col-md12">
                      <label htmlFor="">Leave To</label>
                      <input
                        type="date"
                        value={applyLeaves?.LeaveTo}
                        onChange={(e) => {
                          setApplyLeaves({
                            ...applyLeaves,
                            LeaveTo: e?.target?.value,
                            LeaveType: "",
                          });
                          setErrorLeaveType();
                        }}
                        min={
                          minLeaveToDate ||
                          currentDate.toISOString().split("T")[0]
                        }
                        // max={applyLeaves?.LeaveType === "Sick Leave" ? last15DaysDate() : null}

                      />
                      {errorLeaveTo === "userLeaveTo" &&
                      !applyLeaves?.LeaveTo ? (
                        <span className="contact_error-dob">
                          Leave To is required.
                        </span>
                      ) : null}
                    </div>

                    <div className="Addemployee-inputs col-md12">
                      <label htmlFor="">No of Days</label>
                      <input
                        className="no-of-days-cursor"
                        type="number"
                        value={applyLeaves?.NoOfDays}
                        onChange={(e) =>
                          setApplyLeaves({
                            ...applyLeaves,
                            NoOfDays: e?.target?.value,
                          })
                        }
                        onBlur={(e) => {
                          if (!e?.target?.value) {
                            setErrorNoOfDays("userNoOfdays");
                          } else {
                            setErrorNoOfDays("false");
                          }
                        }}
                        disabled
                      />
                      {errorNoOfDays === "userNoOfdays" &&
                      !applyLeaves?.NoOfDays ? (
                        <span className="contact_error-dob">
                          No Of Days is required.
                        </span>
                      ) : null}
                    </div>
                    <div className="Addemployee-inputs col-md12">
                      <div className="addemp-react-select-input">
                        <label htmlFor="">Leave Type</label>
                        <Select
                          classNamePrefix="EMP-leave-request-input"
                          placeholder="Select Leave Type"
                          value={applyLeaves?.LeaveType}
                          onChange={handleLeaveTypeChange}
                          options={leaveTypeData}
                          getOptionLabel={(options) => options?.Name}
                          getOptionValue={(options) => options?.Id}
                          onBlur={(e) => {
                            if (!e?.target?.value) {
                              setErrorLeaveType("userLeaveType");
                            } else {
                              setErrorLeaveType("false");
                            }
                          }}
                        />
                        {errorLeaveType === "userLeaveType" &&
                        !applyLeaves?.LeaveType ? (
                          <span className="contact_error-Addemployee">
                            Leave Type is required.
                          </span>
                        ) : null}
                      </div>

                      {applyLeaves.LeaveType.Name === "Sick Leave" && (
                        <div className="File-uploder">
                          <label htmlFor="">Please upload Medical Bills of the Hospital</label>
                          <input
                            type="file"
                            id="profileImage"
                            ref={fileInputRef}
                            onChange={handleImageChange}
                          />
                        </div>
                      )}
                    </div>
                    <div className="Addemployee-inputs col-md12">
                      <label htmlFor="">Reason</label>
                      <textarea
                        className="reason-input"
                        name=""
                        id=""
                        cols="30"
                        rows="8"
                        // placeholder="Reason"
                        value={applyLeaves?.Reason}
                        onChange={(e) =>
                          setApplyLeaves({
                            ...applyLeaves,
                            Reason: e?.target?.value,
                          })
                        }
                        onBlur={(e) => {
                          if (!e?.target?.value) {
                            setErrorReason("userReason");
                          } else {
                            setErrorReason("false");
                          }
                        }}
                      />
                      {errorReason === "userReason" && !applyLeaves?.Reason ? (
                        <span className="contact_error-dob">
                          Reason is required.
                        </span>
                      ) : null}
                    </div>
                    <div className="Addemployee-buttons buttons-for-leave-apply">
                      <button
                        className="Addemployee-submit-button-apply-leave"
                        style={{
                          backgroundColor:
                            applyLeaves?.LeaveType &&
                            applyLeaves?.LeaveFrom &&
                            applyLeaves?.LeaveTo &&
                            applyLeaves?.NoOfDays &&
                            applyLeaves?.Reason
                              ? "#3f51b5"
                              : "rgba(0, 0, 0, .12)",
                          color:
                            applyLeaves?.LeaveType &&
                            applyLeaves?.LeaveFrom &&
                            applyLeaves?.LeaveTo &&
                            applyLeaves?.NoOfDays &&
                            applyLeaves?.Reason
                              ? "#fff"
                              : "rgba(0, 0, 0, .38)",
                        }}
                        onClick={() => handleLeaveSubmit()}
                      >
                        {leaveRequestData ? "Update" : "Submit"}
                      </button>
                      <button
                        className="Addemployee-Cancel-button-apply-leave"
                        style={{
                          backgroundColor:
                            !applyLeaves.LeaveType &&
                            !applyLeaves.LeaveFrom &&
                            !applyLeaves.LeaveTo &&
                            !applyLeaves.Reason
                              ? "rgba(0, 0, 0, 0.12)"
                              : "#F44336",
                          color:
                            !applyLeaves.LeaveType &&
                            !applyLeaves.LeaveFrom &&
                            !applyLeaves.NoOfDays &&
                            !applyLeaves.Reason
                              ? "rgba(0, 0, 0, 0.38)"
                              : "#ffffff",
                        }}
                        onClick={() => handleCancelFields()}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      </div>
    </>
  );
};
export default EMPLeavesRequest;
